import React from 'react';
import PropTypes from 'prop-types';

const FormControls = ({ children }) => (
  <div className="form-edit-controls">
    <div className="form-edit-buttons">
      {children}
      <div className="clearfix" />
    </div>
  </div>
);

FormControls.defaultProps = {
  children: null,
};

FormControls.propTypes = {
  children: PropTypes.node,
};

export default FormControls;
